<template>
    <div>

        <h1 class="display-heading mb-3">Patient Details</h1>
        <div class="mb-3">
            <div class="row mb-3">
                <label class="col-md-3"><b>Name</b></label>
                <div class="col">
                    Alexander Foo
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-md-3"><b>IC / Passport Number</b></label>
                <div class="col">
                    800131-14-7899
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-md-3"><b>Diagnosis</b></label>
                <div class="col">
                    <textarea class="form-control" name="" id="" cols="30" rows="5"></textarea>
                </div>
            </div>
        </div>

        <table class="table table-bordered">
            <colgroup>
                <col width="50">
                <col>
                <col width="250">
            </colgroup>
            <thead>
                <tr>
                    <th>
                        No
                    </th>
                    <th>
                        Items
                    </th>
                    <th>
                        Charges (RM)
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td><a href="javascript:void(0);" data-toggle="modal" data-target="#exampleModal">Consultation</a>
                    </td>
                    <td class="text-right">{{totalConsultations.toFixed(2)}}</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td><a href="javascript:void(0);" data-toggle="modal" data-target="#medicationModal">Medication</a>
                    </td>
                    <td class="text-right">{{totalMedications.toFixed(2)}}</td>
                </tr>
                <tr>
                    <td>3</td>
                    <td><a href="javascript:void(0);" data-toggle="modal" data-target="#treatmentModal">Treatment</a>
                    </td>
                    <td class="text-right">{{totalTreatments.toFixed(2)}}</td>
                </tr>
                <tr>
                    <td></td>
                    <td class="text-right">Total</td>
                    <td class="text-right">{{this.total.toFixed(2)}}</td>
                </tr>
            </tbody>
        </table>

        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Consultation Details</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div class="mb-3">
                                <label>Description</label>
                                <input type="text" class="form-control" v-model="consultation.description">
                            </div>
                            <div class="mb-3">
                                <label>Price</label>
                                <input type="number" class="form-control" v-model="consultation.price">
                            </div>
                            <button @click="addConsultation" class="btn btn-primary btn-primary-insv">
                                Add Item
                            </button>
                        </div>
                        <hr>
                        <table class="table table-bordered">
                            <colgroup>
                                <col width="50">
                                <col>
                                <col width="250">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>No.</th>
                                    <th>Description</th>
                                    <th>Price</th>
                                </tr>
                                <tr v-for="(item, index) in consultations" :key="index">
                                    <td>{{index+1}}</td>
                                    <td>{{item.description}}</td>
                                    <td>{{item.price}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="medicationModal" tabindex="-1" role="dialog" aria-labelledby="medicationModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Medication Details</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div class="mb-3">
                                <label>Description</label>
                                <input type="text" class="form-control" v-model="medication.description">
                            </div>
                            <div class="mb-3">
                                <label>Price</label>
                                <input type="number" class="form-control" v-model="medication.price">
                            </div>
                            <button @click="addMedication" class="btn btn-primary btn-primary-insv">
                                Add Item
                            </button>
                        </div>
                        <hr>
                        <table class="table table-bordered">
                            <colgroup>
                                <col width="50">
                                <col>
                                <col width="250">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>No.</th>
                                    <th>Description</th>
                                    <th>Price</th>
                                </tr>
                                <tr v-for="(item, index) in medications" :key="index">
                                    <td>{{index+1}}</td>
                                    <td>{{item.description}}</td>
                                    <td>{{item.price}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="treatmentModal" tabindex="-1" role="dialog" aria-labelledby="treatmentModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Treatment Details</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div class="mb-3">
                                <label>Description</label>
                                <input type="text" class="form-control" v-model="treatment.description">
                            </div>
                            <div class="mb-3">
                                <label>Price</label>
                                <input type="number" class="form-control" v-model="treatment.price">
                            </div>
                            <button @click="addTreatment" class="btn btn-primary btn-primary-insv">
                                Add Item
                            </button>
                        </div>
                        <hr>
                        <table class="table table-bordered">
                            <colgroup>
                                <col width="50">
                                <col>
                                <col width="250">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>No.</th>
                                    <th>Description</th>
                                    <th>Price</th>
                                </tr>
                                <tr v-for="(item, index) in treatments" :key="index">
                                    <td>{{index+1}}</td>
                                    <td>{{item.description}}</td>
                                    <td>{{item.price}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    'computed': {
        totalTreatments () {
            return this.treatments.map((i) => i.price).reduce((a, b) => a + b, 0);
        },
        totalMedications () {
            return this.medications.map((i) => i.price).reduce((a, b) => a + b, 0);
        },
        totalConsultations () {
            return this.consultations.map((i) => i.price).reduce((a, b) => a + b, 0);
        },
        total () {
            return this.totalTreatments + this.totalMedications + this.totalConsultations;
        }
    },
    data () {
        return {
            'consultations': [

            ],
            'medications': [

            ],
            'treatments': [

            ],
            'consultation': {
                'price': null,
                'description': null
            },
            'medication': {
                'price': null,
                'description': null
            },
            'treatment': {
                'price': null,
                'description': null
            }
        };
    },
    'methods': {
        addConsultation () {
            this.consultations.push({
                'description': this.consultation.description,
                'price': parseFloat(this.consultation.price)
            });

            this.consultation.description = null;
            this.consultation.price = null;
        },
        addMedication () {
            this.medications.push({
                'description': this.medication.description,
                'price': parseFloat(this.medication.price)
            });

            this.medication.description = null;
            this.medication.price = null;
        },
        addTreatment () {
            this.treatments.push({
                'description': this.treatment.description,
                'price': parseFloat(this.treatment.price)
            });

            this.treatment.description = null;
            this.treatment.price = null;
        }
    }
};

</script>
